<template>
  <v-container>
    <div class="d-flex justify-space-between">
      <div class="tabs-max-width">
        <v-tabs v-model="tab" mobile-breakpoint="768px" grow class="tab-btn-style">
          <v-tab class="c-tab" v-if="permitObj.enquiry">Enquiry</v-tab>
          <v-tab class="c-tab" v-if="permitObj.joined">Joined</v-tab>
        </v-tabs>
      </div>
      <!-- {{ permitObj }} -->
      <bread-crumbs></bread-crumbs>
    </div>

    <div class="nmt-1">
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <enquiry-table></enquiry-table>
        </v-tab-item>
        <v-tab-item>
          <joined-table></joined-table>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-container>
</template>

<script>
import BreadCrumbs from "../../../components/BreadCrumbs";
import EnquiryTable from "../../../components/students/EnquiryTable.vue";
import JoinedTable from "../../../components/students/JoinedTable.vue";
import AddToGroupTable from "../../../components/students/AddToGroupTable";
import { getPermitObjects } from "../../../utils/allowedPermissions";

export default {
  name: "Students",
  components: { AddToGroupTable, JoinedTable, EnquiryTable, BreadCrumbs },
  data() {
    return {
      // permitObj: {},
      permitObj: "",
      tab: null,
      breadItems: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
          to: {
            name: "DashBoard"
          }
        },
        {
          text: "Students",
          disabled: true,
          to: {
            name: "Students"
          }
        }
      ]
    };
  },
  methods: {
    getPermittedArray() {
      let links = this.$store?.getters?.permissions;
      let pathName = "APStudents";
      this.permitObj = getPermitObjects(links, pathName);
    }
  },
  mounted() {
    this.getPermittedArray();
  }
};
</script>

<style  lang="scss">
.nmt-1 {
  margin-top: -12px;
}
.c-tab {
  background: #f2f0f0;
  transition: background-color 0.2s;
  &.v-tab--active {
    background: white;
  }
}
</style>
<style scoped>
.tabs-max-width {
  width: 200px;
}
@media only screen and (max-width: 768px) {
  .tabs-max-width {
    width: 100% !important;
    min-width: 100% !important;
  }
  .d-flex.justify-space-between {
    display: block !important;
  }
}
</style>